<template>
  <div class="controller-review">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tên" prop="name">
          <a-input v-model="form.name" placeholder="Tên" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Nội dung" prop="content">
          <a-textarea :rows="4" v-model="form.content" placeholder="Nội dung" />
        </a-form-model-item>
        <a-form-model-item>
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import { createReview, updateReview, fetchReviewById } from '@/services/landing-page/review'
  export default {
    name: 'ControllerReview',
    data() {
      return {
        callingAPI: false,

        form: {
          name: '',
          content: '',
        },
        rules: {
          name: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
          content: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
        },

        avatarUrl: "",
      }
    },
    async beforeMount() {
      if (this.$route.params.id) {
        await this.loadData()
      }
    },
    methods: {
      async loadData() {
        try {
          const response = await fetchReviewById(this.$route.params.id)
          this.form.name = response.data.name
          this.form.content = response.data.content
        } catch (error) { }
      },
      handleSubmit(e) {
        e.preventDefault();
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              this.callingAPI = true

              const data = {
                name: this.form.name,
                content: this.form.content
              }

              if (this.$route.params.id) {
                data._method = 'PUT'
              }

              let response = null;
              if (this.$route.params.id) {
                 response = await updateReview(this.$route.params.id, data)
              } else {
                 response = await createReview(data)
              }
              if (response.status == 1) {
                const message = this.$route.params.id
                  ? "Cập nhật thành công."
                  : "Thêm mới thành công.";
                this.$notification.success({
                  message: "Thành công",
                  description: message,
                });
                this.$router.push({ name: "CustomerReview" });
              } else {
                this.$notification.error({
                  message: "Thất bại",
                  description: response.errors[0],
                });
              }
            } catch (error) {
              this.callingAPI = false
              console.log(error);
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>